class StorageService {
  public setObject = (key: string, object: any) => {
    localStorage.setItem(key, JSON.stringify(object));
  }

  public getObject = (key: string) => {
    const object = localStorage.getItem(key);
    return object && JSON.parse(object);
  }

  public getItem = (key: string) => {
    return localStorage.getItem(key);
  }

  public clear = () => {
    localStorage.clear();
  }
}

export default new StorageService();
